import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import { useLocation } from 'react-router';
import DataContainer from 'Components/UI/DataContainer';
import useCollection from 'Hooks/useCollection';
import useModalClosedEffect from 'Hooks/useModalClosedEffect';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import usePrevious from 'Hooks/usePrevious';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import modalConsts from 'Consts/ModalNames';
import { convertBalanceSheetCollectionToItems } from 'Helpers/BalanceSheet';
import BalanceSheet from './index';

const BalanceSheetContainer = (props) => {
  const { householdResource } = useSimpleHousehold();
  const { collection, setCollection } = useCollection();
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);
  const location = useLocation();
  const prevLocation = usePrevious(location);

  async function fetchData(hhResource) {
    try {
      const coll = await hhResource.relationship(fr.relationships.householdBalanceSheetLegacy.name).link('related').get();
      setCollection(coll);
    } catch (err) {
      setLoadingError(err);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (householdResource) {
      fetchData(householdResource)
        .catch(err => displayErrorMessage(err, err.errors));
    }
  }, [householdResource]);

  useModalClosedEffect(modalConsts.realAssetModal, (hhResource) => {
    fetchData(hhResource)
      .catch(err => displayErrorMessage(err, err.errors));
  }, [householdResource]);

  useEffect(() => {
    if (prevLocation
      && prevLocation.search !== location.search
      && prevLocation.search.includes('modal')
      && !location.search.includes('modal')) {
      if (householdResource) {
        fetchData(householdResource)
          .catch(err => displayErrorMessage(err, err.errors));
      }
    }
  }, [location]);

  return (
    <DataContainer
      backgroundColor="white"
      loading={loading}
      loadingError={loadingError}
      ErrorListProps={{
        title: 'An error occurred while loading the Balance Sheet',
      }}
    >
      <BalanceSheet
        data={convertBalanceSheetCollectionToItems(collection)}
        householdResource={householdResource}
        {...props}
      />
    </DataContainer>
  );
};

export default BalanceSheetContainer;
